import { Component, OnInit } from '@angular/core';
import { MetaService } from '../meta.service';

@Component({
  selector: 'app-oscal',
  templateUrl: './oscal.component.html',
  styleUrls: ['./oscal.component.css']
})
export class OscalComponent implements OnInit {

  constructor(private mds: MetaService) { }

  ngOnInit(): void {
    //SEO Optimization
    var strTitle = 'RegScale - OSCAL Support';
    var description = 'RegScale is purpose built on top of the OSCAL standard to support continuous compliance automation';
    var keywords = 'RegScale, OSCAL, automation, RMF, compliance as code, catalogues, profile, SSP, components, SAP, SAR, POAM';
    this.mds.updateTags(strTitle, keywords, description);
  }

}
